import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import PlayPage from "@/pages/play/page";
import DetailPage from "@/pages/detail/page";
import CastPage from "@/pages/cast/page";
import UpdatesPage from "@/pages/updates/page";
import RelatedPage from "@/pages/related/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/play/:episodeId",
    element: <PlayPage />,
  },
  {
    path: "/detail",
    element: <DetailPage />,
  },
  {
    path: "/cast",
    element: <CastPage />,
  },
  {
    path: "/updates",
    element: <UpdatesPage />,
  },
  {
    path: "/related",
    element: <RelatedPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;